<div class="status-aggregation-container" *ngIf="statusAggregations.length > 0">
    <div *ngFor="let status of statusAggregations"
         class="status-circle"
         [class]="status.class"
         [class.status-circle--invisible]="status.visible === false"
         [ngbTooltip]="status.visible ? status.label + ': ' + status.count : ''"
         [attr.role]="status.visible ? 'img' : 'presentation'"
         [attr.aria-label]="status.visible ? status.label + ', ' + status.count : ''">
        <span aria-hidden="true">{{ getDisplayCount(status.count) }}</span>
        <span class="visually-hidden" *ngIf="status.visible">{{ status.label }}, {{ status.count }}</span>
    </div>
</div>